// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1BmBh","list":"PatternAutocomplete_list__36eKI"};